import Fuse from 'fuse.js';
import cloneDeep from 'lodash/cloneDeep';

export async function onSearchByText(
    text = '',
    initData = [],
    ) {
    if (text?.length === 0 || initData?.length === 0)
      return [...initData];
  
    // Configs
    const options = {
      keys: ['title']
    };
  
    // Lets Search
    let result = [];
    result = [...initData];
    initData.forEach((item, i) => {
      const fuse = new Fuse(
         item,
        options
      );
      let searchResult = fuse.search(text);
      searchResult = searchResult.map((v) => v.item);
      result[i] = searchResult;      
    })
    return result;
}

  
export async function onSearchByText2(text = '', initData = []) {
    if (text?.length === 0 || initData?.length === 0) return [...initData];

    // Lets Search
    let result = cloneDeep(initData);
    result = result.map(item => item?.map(el => ({...el, planningList: el.planningList?.map(p => ({...p, courses: []}))})));
    initData.forEach((parent, i) => {
      parent?.forEach?.((item, j) => {
        item?.planningList?.forEach((element, k) => {
          element?.courses?.forEach(child => {
            if(child.title.includes(text)) {
              result[i][j].planningList[k].courses.push(child);
            }
          })
        })
      })
    })
    result = result.map(item => {
      return item.filter(el => {
        if(Array.isArray(el.planningList)) {
          for(let p of el.planningList) {
            if(p.courses?.length !== 0) {
              return true
            }
          }
        }
        return false
      })
    })
    return result
  }
  
  /**
   * From group orientations data
   * @param {Array} list - Array of objects
   * @param {String} key - key to remove from each object of array
   *
   * @return {Array} Formatted data array
   */
  export const removeArrayKey = (list = [], key) => {
    if (!key) return list;
    const formatted = cloneDeep(list);
    for (let i = 0; i < list.length; i++) {
      if (formatted[i][key]) {
        delete formatted[i][key];
      }
    }
    return formatted;
  };
  